const note = 'Не выбрано';

export const zwanieList = [
  { id: '1', text: note, textEN: 'Not selected' },
  { id: '2', text: 'Доцент', textEN: 'Associate Professor' },
  { id: '3', text: 'Профессор', textEN: 'Professor' },
  { id: '4', text: 'Академик', textEN: 'Academician' },
  {
    id: '5',
    text: 'Член-корреспондент академии наук',
    textEN: 'Corresponding Member of the Academy of Sciences',
  },
  { id: '6', text: 'Старший научный сотрудник', textEN: 'Senior Research Fellow' },
  { id: '7', text: 'Другое', textEN: 'Other' },
];

export const stepenList = [
  { id: '1', text: note, textEN: 'Not selected' },
  { id: '2', text: 'Кандидат наук', textEN: 'Candidate of Sciences' },
  { id: '3', text: 'Доктор наук', textEN: 'Doctor of Sciences' },
  { id: '4', text: 'PhD', textEN: 'PhD' },
  { id: '5', text: 'Другое', textEN: 'Other' },
];

export const doljnostList = [
  { id: '1', text: note, textEN: 'Not selected' },
  { id: '2', text: 'Студент', textEN: 'Student' },
  { id: '3', text: 'Лаборант', textEN: 'Laboratory Assistant' },
  { id: '4', text: 'Старший преподаватель', textEN: 'Senior Lecturer' },
  { id: '5', text: 'Профессор', textEN: 'Professor' },
  { id: '6', text: 'Заведующий кафедрой', textEN: 'Head of Department' },
];

export const directionConferenceList = [
  { id: '1', text: 'Информационная безопасность', textEN: 'Information Security' },
  {
    id: '2',
    text: 'Управление системами с распределенными параметрами',
    textEN: 'Control of Systems with Distributed Parameters',
  },
  { id: '3', text: 'Беспилотные автоматизированные системы', textEN: 'Unmanned Automated Systems' },
  {
    id: '4',
    text: 'Интеллектуальная обработка информации',
    textEN: 'Intelligent Information Processing',
  },
  {
    id: '5',
    text: 'Современные образовательные технологии в области подготовки инженерных кадров',
    textEN: 'Modern Educational Technologies in Engineering Education',
  },
  {
    id: '6',
    text: 'Проблемы математического моделирования и управления в области медицины',
    textEN: 'Problems of Mathematical Modeling and Control in Medicine',
  },
  {
    id: '7',
    text: 'Математическое моделирование в астрофизике, геофизике и инженерных науках',
    textEN: 'Mathematical Modeling in Astrophysics, Geophysics and Engineering',
  },
  {
    id: '8',
    text: 'Искусственный интеллект в управлении: теория и практика',
    textEN: 'Artificial Intelligence in Control: Theory and Practice',
  },
  {
    id: '9',
    text: 'Проблемы самоорганизации и управления в сложных технических системах',
    textEN: 'Self-organization and Control Problems in Complex Technical Systems',
  },
];

export const formParticipationList = [
  { id: '1', text: 'Очно', textEN: 'In-person' },
  { id: '2', text: 'Заочно', textEN: 'Remote' },
];

export const participationStatus = [
  { id: '1', text: 'Участник', textEN: 'Participant' },
  { id: '2', text: 'Студент', textEN: 'Student' },
  { id: '3', text: 'Аспирант', textEN: 'Postgraduate Student' },
];
